import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, className = '' }) => {
    return (
        <section className={`bg-gray-950 py-16 ${className}`}>
            <div className="max-w-6xl mx-auto px-6 text-center">
                <h1 className="text-4xl md:text-6xl font-semibold text-gray-50 tracking-tight mb-4">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                        {subtitle}
                    </p>
                )}
            </div>
        </section>
    );
};

export default PageHeader;
